import moment from "moment";
import "moment/locale/pt";
import { Calendar, momentLocalizer } from "react-big-calendar";

import "react-big-calendar/lib/css/react-big-calendar.css";
type SchoolCalendarProps ={
    events:any
}
moment.locale("pt");
const localizer = momentLocalizer(moment);
export const SchoolCalendar = ({ events }:SchoolCalendarProps) => {
    const messages = {
        allDay: "Dia inteiro",
        previous: "Anterior",
        next: "Próximo",
        today: "Hoje",
        month: "Mês",
        week: "Semana",
        day: "Dia",
        agenda: "Agenda",
        date: "Data",
        time: "Hora",
        event: "Evento",
        noEventsInRange: "Não há eventos neste período.",
        showMore: (total: any) => `+ Ver mais (${total})`,
      };

    return (
        <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 500 }}
            messages={messages} 
        />);
}
